import { VerificationCodeForm } from '@core/Areas/Settings/Components/MFASettings'
import {
  MfaCodePageHeader,
  MfaCodePageText,
  MfaVerificationCodePageContainer,
} from '@core/Areas/Settings/Components/MFASettings/Pages/VerificationCodePage.styles'
import { MainContainer } from '@core/Components/Containers'
import React, { useEffect, useState } from 'react'
import type { useLoginState } from '../../hooks'
import { HelpText } from '@core/Components/Messages/HelpText'
import { mfaCodeText } from '@core/Areas/Settings/Components/MFASettings/Helpers/helpers'

export const LoginVerificationCodePage = ({
  state,
  handlers,
}: ReturnType<typeof useLoginState>) => {
  const [lastKnownHint, setLastKnownHint] = useState(state.mfaHint)
  const [lastKnownFactor, setLastKnownFactor] = useState(state.mfaFactor)

  useEffect(() => {
    if (state.mfaHint) setLastKnownHint(state.mfaHint)
    if (state.mfaFactor) setLastKnownFactor(state.mfaFactor)
  }, [state.mfaHint, state.mfaFactor])

  const displayHint = state.mfaHint || lastKnownHint
  const displayFactor = state.mfaFactor || lastKnownFactor
  const disableForm = state.errorMessage == 'Too many unsuccessful attempts'

  if (!displayFactor || !displayHint) {
    return (
      <MainContainer data-tid-mfa-verification-page background='white'>
        <MfaVerificationCodePageContainer>
          <MfaCodePageHeader>Verify Your Identity</MfaCodePageHeader>
          <p>There was an error trying to verify your identity.</p>
        </MfaVerificationCodePageContainer>
      </MainContainer>
    )
  }

  return (
    <MainContainer data-tid-mfa-verification-page background='white'>
      <MfaVerificationCodePageContainer>
        <VerificationCodeForm
          onVerify={handlers.handleMfaChallenge}
          onResend={handlers.handleMfaChallengeResend}
          isLoading={state.isBusy}
          disabled={disableForm}
          errorMessage={state.errorMessage}
          onErrorReset={() => handlers.setErrorMessage(undefined)}
          analyticsFlowName='Login'
          analyticsMethodName={displayFactor}
        >
          <MfaCodePageText>{mfaCodeText(displayFactor, displayHint)}</MfaCodePageText>
        </VerificationCodeForm>
      </MfaVerificationCodePageContainer>
      {state.errorMessage ? (
        <HelpText>
          If you need to update your contact details, please call us on <b>1300 36 36 88</b>
        </HelpText>
      ) : null}
    </MainContainer>
  )
}
